import axios from '@axios'

/**
 * Gets a pre-signed URL from the backend and uploads the error log to S3.
 * @param {Error} err The error object.
 * @param {Vue} vm The component instance where the error occurred.
 * @param {String} info Vue specific error information (e.g., lifecycle hook).
 */
export default async function logErrorToS3(err, vm, info) {
  try {
    // 1. Get a signed URL from your API
    // Ensure the API endpoint path is correct and uses the base URL from environment variables.
    const apiBaseUrl = process.env.VUE_APP_API_URL || 'https://brs-api.tubtimcrm.com'; // Get the base URL from environment variables
    const { data: { data: signedUrlResponse } = {} } = await axios.post(`${apiBaseUrl}/upload/get-signed-url`, {
      originURL: window.location.href,
    })

    const { uploadUrl } = signedUrlResponse

    // 2. Prepare the error log data
    const errorLog = {
      error: {
        message: err.message,
        stack: err.stack,
      },
      info,
      component: vm && vm.$options ? vm.$options.name || vm.$options._componentTag : 'Unknown Component',
      location: window.location.href,
      timestamp: new Date().toISOString(),
    }

    // 3. Upload the log to S3 using the signed URL
    // The Content-Type must match what the backend expects for the signed URL.
    await axios.put(uploadUrl, JSON.stringify(errorLog), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  } catch (loggingError) {
    console.error('Failed to log error to S3:', loggingError)
  }
}